/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import React, {
 ChangeEvent,
 useCallback,
 useEffect,
 useState,
} from 'react'
import {useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {CheckboxField, KTSVG} from 'helpers'
import {KTFilterBox} from 'helpers/ui-components/KTFilterBox'
import {KTSearchBox} from 'helpers/ui-components/KTSearchBox'
import {
 fetchUserList,
 bulkApproveRejectUsers,
 sendVerificationLink,
} from 'utils/api/auth/userManagementService'
import {fetchFilterConfig} from 'utils/api/auth/commonService'
import {
 IApproveReject,
 IUser,
 IUserAction,
} from 'models/UserManagement'
import {ColumnProps, IFormField} from 'models/Common'
import KTTable from 'helpers/ui-components/KTTable'
import {DefaultApiResponse} from 'models/ApiResponse'
import {toast} from 'react-toastify'
import {formatDateForDisplay} from 'utils/helper'
import {createFilterPayload} from 'utils/helpers/genericFilterForm'

type IProps = {
 accessDetails: IFormField
 loggedInUserId: number | undefined
 actionDetails?: IUserAction | null
 setLoader: (newState: boolean) => void
 setActionDetails: (newState: IUserAction | null) => void
}

const PendingUserAction = (props: IProps) => {
 const {t} = useTranslation()
 const [currentPage, setCurrentPage] = useState(1)
 const [userListRes, setUserListRes] =
  useState<DefaultApiResponse>()
 const [userList, setUserList] = useState<IUser[]>([])
 const [tableColList, setTableColList] = useState<
  Array<ColumnProps<IUser>>
 >([])
 const [itemsPerPage, setItemsPerPage] = useState(25)
 const [searchTerm, setSearchTerm] = useState('')
 const [filterConfig, setFilterConfig] = useState<
  IFormField[]
 >([])
 const [filterFormData, setFilterFormData] =
  useState<IFormField | null>({})
 const [filterCount, setFilterCount] = useState(0)
 const {
  register,
  getValues,
  setValue,
  reset,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
 })

 const {accessDetails, setLoader, setActionDetails} = props

 const pendingUserAccess =
  accessDetails?.pendingUserAction?.section
 const userDetailsAccess =
  accessDetails?.userDetails?.section

 const getFilterConfig = useCallback(async () => {
  try {
   const res = await fetchFilterConfig({
    filter_type: 'USER',
   })
   if (res) {
    setFilterConfig(res?.applicableFilters ?? [])
   }
  } catch (error) {
   setFilterConfig([])
  }
 }, [])

 const handleUserClick = async (record: IUser) => {
  console.log('sdf', record)
 }

 useEffect(() => {
  void getFilterConfig()
 }, [getFilterConfig])

 const getUserList = useCallback(
  async (
   pageNo = 1,
   pageSize = 10,
   signal?: AbortSignal
  ) => {
   setLoader(true)
   try {
    let query: IFormField = {}
    let appliedFilters = 0
    if (filterConfig?.length) {
     const payload = await createFilterPayload(
      filterConfig,
      filterFormData
     )
     const {totalAppliedFilters, ...restPayload} = payload
     appliedFilters =
      typeof totalAppliedFilters === 'number'
       ? totalAppliedFilters
       : Number(totalAppliedFilters ?? 0)
     query = restPayload as IFormField
    }
    const trimmedSearch = searchTerm.trim()
    if (trimmedSearch) {
     query = {
      ...query,
      search: trimmedSearch,
     }
    }
    const res: DefaultApiResponse | null =
     await fetchUserList(
      'phone_no_verification_pending',
      pageNo,
      pageSize,
      Object.keys(query).length ? query : undefined,
      signal
     )
    if (res) {
     setUserListRes(res)
     setUserList(res.results ?? [])
    }
    setFilterCount(appliedFilters)
   } finally {
    setLoader(false)
   }
  },
  [filterConfig, filterFormData, searchTerm, setLoader]
 )

 useEffect(() => {
  if (currentPage !== 1) {
   setCurrentPage(1)
  }
  const abortController = new AbortController()
  void getUserList(1, itemsPerPage, abortController.signal)
  return () => {
   abortController.abort()
  }
 }, [filterFormData, searchTerm, itemsPerPage])

 const handlePageChange = async (pageNo: number) => {
  setCurrentPage(pageNo)
  await getUserList(pageNo, itemsPerPage)
 }

 const handleItemsPerPageChange = (pageSize: number) => {
  setItemsPerPage(pageSize)
  setCurrentPage(1)
 }

 const handleSelectAll = useCallback(
  async (e: ChangeEvent<HTMLInputElement>) => {
   const isChecked = e.target.checked
   userList.forEach((item) => {
    setValue(`userIds.${item.id}`, isChecked)
   })
  },
  [setValue, userList]
 )

 async function handleUserAction(isSendReminder?: boolean) {
  const users: number[] = []
  const sendReminderUserList: IFormField[] = []
  userList.forEach((item, index) => {
   const val = getValues(`userIds.${item.id}`)
   if (val) {
    users.push(item.id)
    sendReminderUserList.push({
     full_name: item.full_name,
     organisation: item.organisation,
     user_category: item.user_category,
     phone_number: item.phone_number,
    })
   }
  })
  if (users.length > 0) {
   setLoader(true)
   if (isSendReminder) {
    const payload = {
     user_data: sendReminderUserList,
    }
    const res: DefaultApiResponse | null =
     await sendVerificationLink(payload)
    setLoader(false)
    if (res) {
     reset()
     toast.success(res.message)
     await getUserList(currentPage, itemsPerPage)
    }
   } else {
    const payload: IApproveReject = {
     user_ids: users,
     status: 'rejected',
    }
    const res: DefaultApiResponse | null =
     await bulkApproveRejectUsers(payload)
    setLoader(false)
    if (res) {
     reset()
     toast.success(res.message)
     await getUserList(currentPage, itemsPerPage)
    }
   }
  } else {
   toast.error(t('common.pleaseSelectUser'))
  }
 }

 const handleActionBtnClick = useCallback(
  (userId: number) => {
   setActionDetails({
    userId: userId.toString(),
    actionType: 'pending_user_action',
   })
  },
  [setActionDetails]
 )

 const renderTableData = useCallback(async () => {
  setLoader(true)

  const columns: Array<ColumnProps<IUser>> = [
   ...(pendingUserAccess?.sendReminder?.canEdit ||
   pendingUserAccess?.reject?.canEdit
    ? [
       {
        key: 'select',
        title: (
         <div className='cursor-pointer text-[#4E83E4] font-semibold'>
          <CheckboxField
           type='checkbox'
           label=''
           className={`w-6 h-6 mt-1 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 focus:ring-2 border-neutral-30`}
           wrapperClassName=''
           name={`selectAll`}
           id={`selectAll`}
           value={'1'}
           register={register('selectAll', {
            onChange: (e) => {
             void handleSelectAll(e)
            },
           })}
          />
         </div>
        ),
        render: (_: ColumnProps<IUser>, record: IUser) => {
         return (
          <div className='cursor-pointer text-[#4E83E4] font-semibold text-center'>
           <CheckboxField
            type='checkbox'
            label=''
            className={`w-6 h-6 mt-1 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 focus:ring-2 border-neutral-30`}
            wrapperClassName=''
            value={record.id}
            name={`userIds-${record.id}`}
            id={`userIds-${record.id}`}
            register={register(`userIds.${record.id}`, {
             required: false,
            })}
           />
          </div>
         )
        },
       },
      ]
    : []),
   {
    key: 'srNo',
    title: t('userManagement.userListTable.srNo'),
    className: 'w-[80px] text-center',
    isSrNo: true,
   },
   {
    key: 'full_name',
    title: t('userManagement.userListTable.name'),
    render: (_, record) => {
     return (
      <button
       type='button'
       disabled={!userDetailsAccess}
       className={`${
        userDetailsAccess && 'text-[#4E83E4] underline'
       } w-full text-left disabled:bg-transparent`}
       onClick={() => {
        if (userDetailsAccess)
         void handleActionBtnClick(record.id)
       }}
      >
       {record.full_name}
      </button>
     )
    },
   },
   {
    key: 'organisation',
    title: t('userManagement.userListTable.firmName'),
   },
   {
    key: 'phone_number',
    title: t('userManagement.userListTable.mobile'),
    className: 'w-[80px]',
   },
   {
    key: 'created_at',
    title: t(
     'userManagement.userListTable.userCreationDate'
    ),
    render: (_, record) => {
     return formatDateForDisplay(record?.created_at)
    },
   },
   {
    key: 'stakeholder',
    title: t('userManagement.userListTable.stakeholder'),
   },
   {
    key: 'category',
    title: t('userManagement.userListTable.category'),
   },
   {
    key: 'user_category',
    title: t('userManagement.userListTable.userCategory'),
   },
  ]
  setTableColList(columns)
  setLoader(false)
 }, [
  handleActionBtnClick,
  handleSelectAll,
  pendingUserAccess,
  register,
  setLoader,
  t,
  userDetailsAccess,
 ])

 useEffect(() => {
  if (userList) {
   void renderTableData()
  }
 }, [renderTableData, userList])

 return (
  <>
   <div className='w-full'>
    <div className='text-[#171B1F] text-xl font-bold'>
     {t('userManagement.pendingUserAction.title')}
     <p className='text-[#5A6066] text-xs font-normal pt-1'>
      {t('userManagement.pendingUserAction.subTitle')}
     </p>
    </div>
    <div className='my-6'>
     <div className='grid md:grid-cols-2 items-center gap-4'>
      <KTSearchBox
       label={t('userManagement.pendingUserAction.search')}
       placeholder={t(
        'userManagement.pendingUserAction.searchPlaceholder'
       )}
       setSearchTerm={setSearchTerm}
      />
      {filterConfig?.length > 0 && (
       <div className='flex gap-4 items-center justify-end'>
        <KTFilterBox
         parentId='pending_user_action'
         btnText={t(
          'userManagement.pendingUserAction.filters'
         )}
         containerClass='bg-white border-none mt-0 pl-0 justify-end'
         filterConfig={filterConfig}
         filterFormData={filterFormData ?? {}}
         setFilterFormData={setFilterFormData}
         filterCount={filterCount}
         setLoader={setLoader}
         showDateRangeBox={false}
        />
       </div>
      )}
     </div>
    </div>
    <div className='flex items-center justify-end text-[#171B1F] bg-[#F5F8FA] text-xl font-bold rounded-lg p-4 my-6'>
     {/* <div className='flex items-center '>
      <Button
       disabled={false}
       onClick={() => {}}
       color='white'
       className='text-center py-[9px] p-3 bg-white 
                          !rounded-lg text-sm !text-[#4E83E4] font-semibold border-[#E6EBF0]'
      >
       <KTSVG
        path={`/media/icons/filter.svg`}
        svgClassName={`w-4 h-4 text-white mr-2`}
       />
       {t('helperText.filter')}
      </Button>
     </div> */}
     <div className='flex items-end '>
      {pendingUserAccess?.reject?.canEdit && (
       <Button
        type='button'
        onClick={() => {
         void handleUserAction(false)
        }}
        disabled={false}
        color='blue'
        className='text-center py-[9px] px-6 bg-[#FFEBED] 
                     !rounded-lg text-base text-[#CC293F] font-semibold border-[#CC293F] hover:bg-[#CC293F] hover:text-white mr-4 w-[167px]'
       >
        {t('userManagement.pendingUserAction.reject')}
       </Button>
      )}
      {pendingUserAccess?.sendReminder?.canEdit && (
       <Button
        type='button'
        onClick={() => {
         void handleUserAction(true)
        }}
        disabled={false}
        color='blue'
        className='text-center py-[9px] px-6 bg-[#4E83E4] hover:bg-white hover:text-[#4E83E4]
                     !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
       >
        {t('userManagement.pendingUserAction.sendReminder')}
       </Button>
      )}
     </div>
    </div>
    <div>
     <KTTable
      data={userList}
      columns={tableColList}
      headerClass='bg-[#80868C]'
      headerColClass='!border-0 text-left'
      colClass='text-[#33393D] !text-sm font-normal !border-0 !py-3'
      tableClass=''
      rowClass='even:bg-[#E6EBF0]'
      showPagination={true}
      currentPage={currentPage}
      itemsPerPage={itemsPerPage}
      totalRecord={userListRes?.count}
      onPageChange={handlePageChange}
      setItemsPerPage={handleItemsPerPageChange}
     />
    </div>
   </div>
  </>
 )
}

export default PendingUserAction
